import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Tween } from 'react-gsap';
import ImageBackground from '../../image-background';
import Section from '../Section.jsx';
import styles from './SectionImageText.module.scss';

function SectionImageText({ zIndex, debug, showTitlesOnSide, isLast, className, imageClassName, imageSrc, imagePosition, imageCredit, imageCreditClassName, textClassName, text, children }) {
  const imageEl = (
    <ImageBackground
      src={imageSrc}
      className={classnames(styles.image, imageClassName)}
    >
      {children}
    </ImageBackground>
  );
  const imageCreditEl = imageCredit && (
    <div className={classnames(styles.credit, imageCreditClassName)}>
      {imageCredit}
    </div>
  );
  const textEl = (
    <p className={classnames(styles.text, textClassName)}>
      {text}
    </p>
  );
  return (
    <Section zIndex={zIndex} debug={debug} isLast={isLast} showTitlesOnSide={showTitlesOnSide} scrub className={classnames(styles.section, className)}>
      {
        imagePosition === 'left' ? (
          <>
            <Tween from={{ opacity: 0, x: '-20%' }} to={{ opacity: 1, x: '0%' }}>
              <div>{imageEl}{imageCreditEl}</div>
            </Tween>
            <Tween from={{ opacity: 0, scale: 1.25 }} to={{ opacity: 1, scale: 1 }}>
              {textEl}
            </Tween>
          </>
        ) : (
          <>
            <Tween from={{ opacity: 0, scale: 1.25 }} to={{ opacity: 1, scale: 1 }}>
              {textEl}
            </Tween>
            <Tween from={{ opacity: 0, x: '20%' }} to={{ opacity: 1, x: '0%' }}>
              <div>{imageEl}{imageCreditEl}</div>
            </Tween>
          </>
        )
      }
    </Section>
  );
}

SectionImageText.propTypes = {
  zIndex: PropTypes.number,
  debug: PropTypes.bool,
  showTitlesOnSide: PropTypes.bool,
  isLast: PropTypes.bool,
  className: PropTypes.string.isRequired,
  imageClassName: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  imagePosition: PropTypes.string.isRequired,
  imageCredit: PropTypes.node,
  imageCreditClassName: PropTypes.string,
  textClassName: PropTypes.string.isRequired,
  text: PropTypes.node.isRequired,
  children: PropTypes.node,
};

export default SectionImageText;
